//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Also defined in Rock.Web.UI.Controls.SlidingDateRangePicker, so if changed, please update there as well */
export const TimeUnitType = {
    /** The hour */
    Hour: 0,

    /** The day */
    Day: 1,

    /** The week */
    Week: 2,

    /** The month */
    Month: 3,

    /** The year */
    Year: 4
} as const;

/** Also defined in Rock.Web.UI.Controls.SlidingDateRangePicker, so if changed, please update there as well */
export const TimeUnitTypeDescription: Record<number, string> = {
    0: "Hour",

    1: "Day",

    2: "Week",

    3: "Month",

    4: "Year"
};

/** Also defined in Rock.Web.UI.Controls.SlidingDateRangePicker, so if changed, please update there as well */
export type TimeUnitType = typeof TimeUnitType[keyof typeof TimeUnitType];
